import React, { useState, useEffect } from 'react';
import { ArrowRightOutlined } from '@ant-design/icons';
import HeroImage from 'assets/images/hero.png';
import { Link } from 'react-router-dom';
import { Button, Col, Image, Row, Typography } from 'antd';

const { Title, Paragraph } = Typography;


export default function DealsOfTheMonth() {
    const [timeLeft, setTimeLeft] = useState({
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0,
    });

    const calculateTimeLeft = () => {
        const endDate = new Date('2024-12-30T00:00:00');
        const difference = endDate - new Date();

        if (difference > 0) {
            return {
                days: Math.floor(difference / (1000 * 60 * 60 * 24)),
                hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
                minutes: Math.floor((difference / 1000 / 60) % 60),
                seconds: Math.floor((difference / 1000) % 60),
            };
        } else {
            return { days: 0, hours: 0, minutes: 0, seconds: 0 };
        }
    };

    useEffect(() => {
        const timer = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    return (
        <section className="hero-section bg-white py-5">
            <div className="container">
                <Row className="container d-flex align-items-center py-5">
                    <Col xs={24} lg={12} className="deals-content">
                        <Title level={2} className="mb-4">Deals of the Month</Title>
                        <Paragraph className="mb-4">
                            It is a long established fact that a reader will be distracted by the readable content
                            of a page when looking at its layout. The point of using Lorem Ipsum is that it has
                            a more-or-less normal distribution of letters.
                        </Paragraph>
                        <div className="row g-4 mb-5">
                            {Object.entries(timeLeft).map(([unit, value]) => (
                                <div className="col-3" key={unit}>
                                    <div className="bg-white rounded shadow-sm p-3 text-center">
                                        <h3 className="fw-bold text-primary mb-0">{value}</h3>
                                        <p className="text-uppercase small mb-0">{unit}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                        <Link to={"/products"}>
                            <Button type="primary" size="large" className="deals-button">
                                View All Products <ArrowRightOutlined />
                            </Button>
                        </Link>
                    </Col>
                    <Col xs={24} lg={12} className="deals-image-container d-flex justify-content-center">
                        <Image preview={false} src={HeroImage} alt="Woman in black hat and coat" className="deals-image" />
                    </Col>
                </Row>
            </div>
        </section>
    );
}